import { SessionInfo } from "./Info";

export enum EventType {
  playerJoined = "playerJoined",
  playerLeft = "playerLeft",
  playerQuit = "playerQuit",
  playerConnected = "playerConnected",
  playerDisconnected = "playerDisconnected",
  playerReadied = "playerReadied",
  playerUnreadied = "playerUnreadied",
  playerPassed = "playerPassed",
  youQuit = "youQuit",
  youLoggedOut = "youLoggedOut",
  gameStarted = "gameStarted",
  diceRolled = "diceRolled",
  boxMarked = "boxMarked",
  turnAdvanced = "turnAdvanced",
  phaseAdvanced = "phaseAdvanced",
  gameEnded = "gameEnded",
  colorLocked = "colorLocked",
}

export type SessionEventData = {
  id: string;
  session: SessionInfo;
};
